import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const HighDownPaymentBody = () => {
  return (
    <Typography>Your down payment exceeds our no-haggle price.</Typography>
  );
};

export const HighDownPaymentDisclaimer = () => {
  return (
    <Typography variant="caption" component="div" color="textSecondary">
      The CarMax no-haggle price does not include taxes, title, fees or any
      optional items like MaxCare and Accessories.
    </Typography>
  );
};

export const InformationUnavailableBody = () => {
  return (
    <Typography>
      A technical error occurred on our end. Check back later.
    </Typography>
  );
};

export const FbsUnavailable = () => {
  return (
    <Stack sx={{ gap: 2 }}>
      <Typography color="error">
        We were unable to pre-qualify you for financing at this time.
      </Typography>

      <Typography component="h2" variant="h5" sx={{ mt: 2 }}>
        Let&#700;s review your options.
      </Typography>

      <Typography component="h3" variant="h6">
        Bring your own financing
      </Typography>
      <Typography>
        We accept financing from most banks and outside lenders. Let us know and
        we&#700;ll help make the process easy.
      </Typography>

      <Typography component="h3" variant="h6">
        Add a co-buyer
      </Typography>
      <Typography>
        Submitting with a co-buyer may help you get the car or the terms you
        want.
      </Typography>

      <Typography component="h3" variant="h6">
        Re-apply down the road
      </Typography>
      <Typography>
        Should your situation change, feel free to reach out so we can further
        assist.
      </Typography>
    </Stack>
  );
};

export const PrequalificationDisclaimer = () => {
  return (
    <Typography variant="caption" component="div" color="textSecondary">
      <sup>‡</sup>
      Estimated pre-qualification terms do not constitute an advertisement or
      offer of specific credit terms. Trade-in equity, if applicable, is based
      on the estimated balance on your vehicle loan and your CarMax appraisal
      offer, which is subject to CarMax’s terms and conditions. If you refresh
      your appraisal offer and it changes, it can impact your estimated
      pre-qualification terms. To determine credit availability and specific
      offer terms, you must submit a credit application which will result in
      inquiries that appear on your credit report and may impact your credit
      score and rating.
    </Typography>
  );
};
